/**
 * Calendar feed data access.
 *
 * Mirrors go-service/internal/api/calendar_feed.go: GET
 * /api/admin/calendar-feed mints (lazily) and returns the Company's iCal
 * subscription URL.
 */
import { resource } from "./resource";

export interface CalendarFeed {
  url: string;
}

const feed = resource<CalendarFeed>("/api/admin/calendar-feed");

export const getCalendarFeed = (signal?: AbortSignal): Promise<CalendarFeed> =>
  feed.get(signal);
